import { AwsConfig as AwsConstants } from '../Constants';

import { Alert } from '../../interfaces/cm/Alert';
import BaseService, { RequestInterface } from '../Base';

export default class AlertService extends BaseService {
  constructor() {
    super(AwsConstants.API_CM, 'alert');
  }

  async listAll(unitId: string, fields?: string[]): Promise<Alert[]> {
    const params: RequestInterface = {
      queryStringParameters: super.setFields(fields)
    };
    params.queryStringParameters['unit'] = unitId;

    const res = await super.get<Alert[]>('', params);
    return res;
  }
  async getById(id: string, unitId: string, fields?: string[]): Promise<Alert> {
    const params: RequestInterface = {
      queryStringParameters: super.setFields(fields)

    };
    params.queryStringParameters['unit'] = unitId;
    const res = await super.get<Alert>(id, params);
    return res;
  }
  async create(data: Alert, unitId: string): Promise<Alert> {
    const params: RequestInterface = {
      body: data,
      queryStringParameters: { unit: unitId }
    };

    const res = await super.post<Alert>('', params);
    return res;
  }
  async updateById(id: string, data: Alert, unitId: string): Promise<Alert> {
    const params: RequestInterface = {
      body: data,
      queryStringParameters: { unit: unitId }
    };
    const res = await super.put<Alert>(id, params);
    return res;
  }
  async deleteById(id: string, unitId: string): Promise<void> {
    const params: RequestInterface = {
      queryStringParameters: { unit: unitId }
    };

    await super.delete<void>(id, params);
  }
}
